import { render, staticRenderFns } from "./GuideGeneralBookDiagonalShooting.vue?vue&type=template&id=2468f446&scoped=true&"
import script from "./GuideGeneralBookDiagonalShooting.vue?vue&type=script&lang=ts&"
export * from "./GuideGeneralBookDiagonalShooting.vue?vue&type=script&lang=ts&"
import style0 from "./GuideGeneralBookDiagonalShooting.vue?vue&type=style&index=0&id=2468f446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468f446",
  null
  
)

export default component.exports